import {
  captureEvent,
  extractErrorProperties,
} from "context/posthog/captureEvent";
import { POSTHOG_EVENTS, POSTHOG_FLOWS } from "context/posthog/events";
import { useSomethingWentWrongToast } from "hooks/useSomethingWentWrongToast";

import { useTranslatedToasts } from "../../../hooks/toasts/useTranslatedToasts";
import { useApproveRefundMutation } from "../api/Refunds";
import { REFUNDS_TOASTS } from "../constants/Toasts";

import type { UUID } from "utils";

export function useApproveRefund() {
  const [approveRefund, { isError, isLoading }] = useApproveRefundMutation();
  const { showApproveSuccessToast } = useTranslatedToasts(
    REFUNDS_TOASTS,
    "refunds"
  );

  useSomethingWentWrongToast(isError);

  const handleApproveRefund = async (refundId: UUID, scaToken?: string) => {
    try {
      await approveRefund({ id: refundId, scaToken }).unwrap();

      captureEvent(POSTHOG_EVENTS.approveRefundSucceeded, {
        flow: POSTHOG_FLOWS.approveRefund,
        entityId: refundId,
      });

      showApproveSuccessToast();
    } catch (error) {
      captureEvent(POSTHOG_EVENTS.approveRefundFailed, {
        flow: POSTHOG_FLOWS.approveRefund,
        entityId: refundId,
        ...extractErrorProperties(error),
      });

      throw error;
    }
  };

  return {
    approveRefund: handleApproveRefund,
    isApproveRefundLoading: isLoading,
  };
}
